// import { PRODUCT_TYPES } from "apis/SearchDevices";

const TERMINAL_STATUSES = ['COMPLETED', 'FAILED', 'CANCELED', 'TERMINATED'];
const ACTIVE_STATUSES = ['RUNNING', 'PENDING', 'CONTINUEDASNEW'];

export const isSwUpdateRunning = (statusRes, deviceId) => {
  if (!statusRes || deviceId === undefined) return false;

  const deviceRuntimeStatus = statusRes?.devices?.[deviceId]?.runtime_status;
  const deviceUpgradeStatus = statusRes?.devices?.[deviceId]?.upgrade_status?.status;
  if (!deviceUpgradeStatus || !deviceRuntimeStatus) return false;

  // reached terminal
  if (TERMINAL_STATUSES.includes(deviceRuntimeStatus.toUpperCase())) return false;
  // scheduled but not running yet
  if (deviceRuntimeStatus.toUpperCase() === 'RUNNING' && deviceUpgradeStatus.toUpperCase() === 'SCHEDULED')
    return false;

  return true;
};

// sort by product type, DU > HBF_SERVICE > others
export const sortBundleMember = (device1, device2) => {
  const productType1 = device1.productType;
  const productType2 = device2.productType;

  const isDevice1Donor = ['donor', 'HBF_DONOR'].includes(productType1);
  const isDevice2Donor = ['donor', 'HBF_DONOR'].includes(productType2);
  if (isDevice1Donor) return -1;
  if (!isDevice1Donor && !isDevice2Donor && productType1 === 'HBF_SERVICE') return -1;
  if (!isDevice1Donor && !isDevice2Donor && productType2 === 'HBF_SERVICE') return 1;
};

export const SCREEN_INDEXES = {
  ADD_DEVICES: 0,
  CREATE_SITE: 1,
  IN_PROGRESS: 2,
  SELECT_BEAM: 3,
  HBF_SERVICE: 4,
  SUCCESS: 5
};

export const CLOSE_MODAL_SECONDS = 30;
